import React from "react";
import { Link } from "react-router-dom";
import Logo from "assets/images/ParvoALERT_new_logo.png";

export default () => (
  <Link to="/">
    <div className="site-logo" />
    {/* <img className="site-logo" src={Logo} alt="Parvo Alert" /> */}
  </Link>
);
